import { Controller } from '@hotwired/stimulus';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import Cookies from 'js-cookie';

export default class extends Controller {
  initialize() {
    document.addEventListener('turbo:before-render', this.clearScrollLock);

    this.setVisitorTimezone();
  }

  setVisitorTimezone() {
    Cookies.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone, {
      sameSite: 'Lax'
    });
  }

  disconnect() {
    console.clear();
    document.removeEventListener('turbo:before-render', this.clearScrollLock);
  }

  clearScrollLock = () => {
    clearAllBodyScrollLocks();
  };
}
